/**
 * Action node definitions.
 */

import type { NodeDefinition } from '../types';
import { deviceActionDefinition } from './device-action';

export const actionDefinitions: [string, NodeDefinition][] = [['action', deviceActionDefinition]];
